import * as React from "react"
import type { SVGProps } from "react"
const SvgNumber = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m9 16-.82 3.28a.9.9 0 0 1-.93.72 1 1 0 0 1-.77-.37.9.9 0 0 1-.18-.83L7 16H4.28a1 1 0 0 1-.8-.39 1 1 0 0 1-.18-.86 1 1 0 0 1 .35-.55q.28-.2.63-.2H7.5l1-4H5.78a1 1 0 0 1-.8-.39 1 1 0 0 1-.18-.86 1 1 0 0 1 .35-.55q.28-.2.63-.2H9l.83-3.28a.9.9 0 0 1 .92-.72q.47 0 .78.38.3.37.17.82L11 8h4l.83-3.27a.9.9 0 0 1 .92-.73q.47 0 .78.38.3.37.17.82L17 8h2.73q.5 0 .8.39.3.38.17.86a1 1 0 0 1-.35.55q-.28.2-.62.2H16.5l-1 4h2.73q.5 0 .8.39.3.38.17.86a1 1 0 0 1-.35.55q-.28.2-.62.2H15l-.82 3.28a.9.9 0 0 1-.93.72 1 1 0 0 1-.77-.37.9.9 0 0 1-.18-.83L13 16zm.5-2h4l1-4h-4z" />
  </svg>
)
export default SvgNumber
